<table>
    <tr>
        <td><mat-icon>close</mat-icon></td>
        <td>
            <div [innerHtml]="data"></div>
        </td>
    </tr>
</table>